import { Box, Stack, Typography } from "@mui/material";
import { ARROW_RIGHT, DASHBOARD_RIGHT } from "../../../assets/icons";
import { SvgContainer } from "../../../components";
import theme from "../../../theme/theme";

interface Props {
  title: string;
  iconColor: string;
}

function DashboardActivityCard({ title, iconColor }: Props) {
  return (
    <Stack
      direction={"row"}
      alignItems="center"
      justifyContent={"space-between"}
      mb={3}
    >
      <Stack alignItems={'center'}>
        <Stack direction={"row"} alignItems="center">
          <SvgContainer svg={DASHBOARD_RIGHT} color={iconColor} />
          <Typography ml={1} mb={1}>
            {title}
          </Typography>
        </Stack>
          <SvgContainer svg={ARROW_RIGHT} color={theme.colors.primary} />
      </Stack>
      <Box>
        <Typography fontWeight={540} textAlign="right">Responsable du bara</Typography>
        <Typography fontWeight={540} textAlign="right">En attente</Typography>
      </Box>
    </Stack>
  );
}

export default DashboardActivityCard;
